import HTTPResponseEntity     from '@/js/Shared/Services/HTTP/Entities/HTTPResponseEntity.js';
import MessagesForwardingItem from '../Collections/MessagesForwardingItem.js';

export { MessagesForwardingHTTPMapping as default };

/**
* Messages Forwarding HTTP Mapping
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MessagesForwardingHTTPMapping {
  /**
   * Maps messages forwarding item from http response entity
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {MessagesForwardingItem} item     messages forwarding item
   * @param {HTTPResponseEntity}     response http response entity
   *
   * @return {void}
   */
  map(item, response) {
    if (!response.results) {
        return;
    }

    item.forward_email_count = 0;
    item.forward_emails      = {};

    response.results.forward.forEach((email, index) => {
      item.forward_emails[`forward_email_${index}`] = email;
      item.forward_email_count += 1;
    });

    if (item.forward_email_count === 0) {
      item.forward_emails['forward_email_0'] = '';
    }

    item.keep_local_copy = (response.results.delivery_mode & 4)  ? 1  : 0;

    if (item.forward_email_count > 0) {
      item.forward_enabled = 1;
    }

    if (response.results.delivery_mode & 16) {
      item.forward_enabled = 0;
    }
  }

  mapRequest(item) {
    let payload = {
      forward      : Object.values(item.forward_emails),
      delivery_mode: 1,
    };

    payload.forward = payload.forward.filter(email => email && email.length > 0);

    if (item.keep_local_copy === 1) {
      payload.delivery_mode += 4;
    }

    if (item.forward_enabled !== 1) {
      payload.delivery_mode += 16;
    }

    if (payload.delivery_mode === 17 && payload.forward.length === 0) {
      payload.delivery_mode = 0;
    }

    return payload;
  }
}